import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home/home.vue'
import Map from '@/components/map/index'
import Form from '@/components/form/index'
import Bless from '@/components/bless/index'
import Donation from '@/components/donation/index'
import MyDonation from '@/components/donation/myDonation'
import DonationDetail from '@/components/donation/detail'
import PersonalCenter from '@/components/personal/center'
import PersonalInfor from '@/components/personal/information'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  // base: '/a/',
  routes: [
    {
      path: '/',
      component: Home
    },
    {
      path: '/index',
      name: 'Index',
      component: Home
    },
    {
      path: '/map',
      name: 'Map',
      component: Map
    },
    {
      path: '/form',
      name: 'Form',
      component: Form
    },
    {
      path: '/bless',
      name: 'Bless',
      component: Bless
      // meta: {
      //   title: '百廿华光，由心点亮' // 设置页面标题
      // }
    },
    {
      path: '/donation',
      name: 'Donation',
      component: Donation
      // meta: {
      //   title: '捐款' // 设置页面标题
      // }
    },
    {
      path: '/myDonation',
      name: 'MyDonation',
      component: MyDonation
    },
    {
      path: '/donationDetail',
      name: 'DonationDetail',
      component: DonationDetail
    },
    {
      path: '/personalCenter',
      name: 'PersonalCenter',
      component: PersonalCenter
    },
    {
      path: '/personalInfor',
      name: 'PersonalInfor',
      component: PersonalInfor
    }
  ]
})
// 路由拦截设置标题
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js